import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {KreirajQRcodeTrake, ParamsModelKreirajQRcodeTrake} from '../models/KreirajQRcodeTrake'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/trake/kreirajQRcodeTrake`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: `Bearer ${auth?.access_token ?? ''}`}

export async function getQrCodeTrakeData(params: ParamsModelKreirajQRcodeTrake) {
  return await axios.get<Array<KreirajQRcodeTrake>>(API, {headers: headers, params: params})
}
